<template>
  <a :href="'/posts/' + post.id" class="post">
    <div
      class="postHeader"
      :style="
        'background-image: url(\'' +
          thumbnail +
          '\');background-position:top;background-color: #ffffff;'
      "
    ></div>
    <div class="postFooter">
      <h2 class="postTitle">{{ post.title }}</h2>
      <div class="postFooterFooter">
        <div class="postDate">
          <i class="material-icons post-pc">access_time</i>
          <div class="post-pc">{{ post.published_at.substring(0, 10) }}</div>
          <div class="post-sp">{{ date }},</div>
        </div>
        <div class="postAuthor" v-if="post.source">
          <i class="material-icons post-pc">rss_feed</i> {{ post.source.name }}
        </div>
      </div>
      <div class="postTag">
        <tags :tags="post.tags"></tags>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: ["post", "thumbnail", "date"]
};
</script>

<style lang="scss" scoped>
@import "../../sass/variables";

.post-sp {
  display: none !important;
}
// Medium ~ margin 0.71rem edge対策
@media (min-width: 751px) {
  .post {
    margin: 0 0.71rem 15px;
    color: $cText;
    background: white;
    cursor: pointer;
    &:link,
    &:visited {
      color: $cText;
    }
    &Header {
      position: relative;
      height: calc(((100vw - 60px) / 6 - 10px * 2) * 9 / 16);
      background-size: 100% auto;
      &::after {
        @include anime;
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        background: none;
      }
    }
    &Footer {
      padding: 10px 15px 8px;
      // &Footer{display:flex;}
    }
    &Category,
      // &Viewed{position:absolute;top:0;font-size: 1rem;}
      &Category {
      left: 0;
      padding: 5px 20px;
      color: white;
      background: $cBaseDk;
    }
    // &Viewed{right:0;padding: 5px 15px; color: white;
    //   b{margin-right:2px;font-size: 1.1rem;}
    // }
    .tags {
    }
    &View {
      @include centerY;
      font-size: 10px;
      line-height: 1;
      color: cText(40);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      justify-content: flex-end;
      margin-bottom: 5px;
      i {
        margin-right: 3px;
        font-size: 1.4rem;
      }
    }
    &Title {
      align-items: flex-start;
      overflow: hidden;
      max-height: 3em;
      margin-bottom: 5px;
      font-size: 16px;
      font-weight: bold;
    }
    &Date,
    &Author {
      @include centerY;
      margin-right: 20px;
      font-size: 10px;
      line-height: 1;
      color: #202020;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-bottom: 5px;
      i {
        margin-right: 3px;
        font-size: 1.4rem;
      }
    }
    &:hover {
      opacity: 0.85;
      .postHeader::after {
        background: cBaseDk(0);
      }
    }
    &Tag {
      max-height: 2rem;
      overflow: hidden;
    }
  }
}
// Small
@media screen and (max-width: 750px) {
  .post {
    padding: 10px 0;
    color: $cText;
    cursor: pointer;
    &:link,
    &:visited {
      color: $cText;
    }
    &Header {
      position: relative;
      width: 35%;
      background-size: 100% auto;
      height: calc((100vw - 20px) * 0.35 * 0.6);
      background-position: center !important;
      background-color: #efefef !important;
      &::after {
        @include anime;
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        background: none;
      }
    }
    &Footer {
      padding-left: 20px;
      width: 65%;
      &Footer {
        display: flex;
      }
    }
    &Category,
      // &Viewed{position:absolute;top:0;font-size: 1rem;}
      &Category {
      left: 0;
      padding: 5px 20px;
      color: white;
      background: $cBaseDk;
    }
    // &Viewed{right:0;padding: 5px 15px; color: white;
    //   b{margin-right:2px;font-size: 1.1rem;}
    // }
    .tags {
    }
    &View {
      display: none;
    }
    &Title {
      align-items: flex-start;
      overflow: hidden;
      max-height: 3em;
      font-weight: bold;
    }
    &-pc {
      display: none !important;
    }
    &-sp {
      display: block !important;
    }
    &Date,
    &Author {
      @include centerY;
      margin-right: 10px;
      font-size: 10px;
      line-height: 1;
      color: cText(40);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      i {
        margin-right: 3px;
        font-size: 1.4rem;
      }
    }
    &:hover {
      opacity: 0.85;
      .postHeader::after {
        background: cBaseDk(0);
      }
    }
    &Tag {
      display: none;
    }
  }
}
</style>
